export default __webpack_public_path__ + "static/media/tf-pin.4710e938.svg";